import Image from "react-bootstrap/Image"
import home_photo from '../resource/home_photo.png'

export default function Home() {
    return (
        <div className="light-text pennant-routes margin padding">
            <h2>Welcome to the ANUTC App!</h2>
            <p>
                ANU Tennis Club aims to create a friendly and social atmosphere for tennis players of all skill levels, all year round. For those just starting out, we offer group coaching and social tennis sessions. Experienced players may be eligible to participate in local tournaments, club ladder competitions and advanced training sessions. All members are welcome!
            </p>
            <p>
                This app provides easy access to <strong>ANU Pennant</strong>, <strong>ANU Ladder</strong> and <strong>ANU Intermediate Coaching</strong>, but does require an account. If you are having issues with the app, please contact us on our <a href="https://www.facebook.com/TennisClubANU/" target="_blank">Facebook page</a>.
            </p>


            <h3>How to create an account</h3>
            <p>
                Click the profile picture on top and click "Sign in". Sign in via either Google or Facebook (We don't support email and password for cyber security concerns). After you sign in, a request to participate will be reviewed by admins. Once approved you will have access to the rest of the app!
            </p>
            <p>
                If you have not been approved within 48 hours, please contact us on our <a href="https://www.facebook.com/TennisClubANU/" target="_blank">Facebook page</a>.
            </p>
            <p>
                Please keep in mind that you must be a valid ANUTC member to be approved. An admin will look through the ANUTC members list, so if your name on your profile is not the same as it is when you purchased a membership then you may not be approved immediately. Further details about purchasing an ANUTC membership can be found on our <a href="https://anutennis.org/" target="_blank">website</a>.
            </p>

            <Image src={home_photo} style={{ display: "block", "marginLeft": "auto", "marginRight": "auto", "margin-top": "10%", "margin-bottom": "10%", width: "80%", "maxWidth": "650px" }} />
        </div>
    )
} 
